import React from "react";

interface PageHeaderProps {
  title: string;
  subtitle: string;
  icon?: React.ReactNode;
  showBackButton?: boolean;
  onBack?: () => void;
  actionButtonText?: string;
  onActionButtonClick?: () => void;
  actionButtonIcon?: React.ReactNode;
}

const PageHeader: React.FC<PageHeaderProps> = ({
  title,
  subtitle,
  icon,
  showBackButton = true,
  onBack,
  actionButtonText,
  onActionButtonClick,
  actionButtonIcon,
}) => {
  return (
    <div className="flex bg-white shadow h-[80px] p-4 items-center justify-between mb-8">
      <div className="flex items-center space-x-4">
        {showBackButton && (
          <button 
            onClick={onBack}
            className="p-2 rounded-lg bg-gray-100 hover:bg-gray-200 transition-colors"
          >
            ← Back to Dashboard
          </button>
        )}
        <div className="flex items-center space-x-3">
          {icon}
          <div>
            <h1 className="text-2xl font-bold text-gray-900">{title}</h1>
            <p className="text-gray-600">{subtitle}</p>
          </div>
        </div>
      </div>
      {actionButtonText && (
        <button 
          onClick={onActionButtonClick}
          className="flex items-center space-x-2 bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700 transition-colors"
        >
          {actionButtonIcon}
          <span>{actionButtonText}</span>
        </button>
      )}
    </div>
  );
};

export default PageHeader;